import rootReducer from '../reducers/rootReducer';
import configureStore from './configureStore';

export const {store, persistor} = configureStore(rootReducer);
